export default __webpack_public_path__ + "static/media/WNo.8-11.36a2b41b.jpg";